module.exports = __webpack_public_path__ + "static/favicon-c98f6a1e549ab83566d30d451f313d60.ico";